<div *ngIf="isPrequalANXEnabled || isBuyNow">
  <div class="row m-0 prequal-info d-block" *ngIf="!showConfirmation">
    <ngx-ui-loader [loaderId]="'creditApplicationPreQual'"
      [ngClass]="{'isBackButton': hasbackButton, 'noBackButton': !hasbackButton}"></ngx-ui-loader>
      <div *ngIf="apiDomain && storeDataWithDomain && storeDataWithDomain.Brands " class="store-info-t3">
        <div class="store-info-log" >
            <span *ngFor="let store of storeDataWithDomain.Brands" >
                <img  src="{{store}}" onerror='this.style.display = "none"'/>
            </span>
        </div>
         <div  class="store-info-name">
          {{storeDataWithDomain.storeName}}
        </div>
      </div>
    <h1 class="col-12  p-0 prequal-title an-h-line-height text-secondary-dark" [ngClass]="{'legacy-credit-prequal-title':  isLegacyCreditApp, 'prequal-title-t3' : apiDomain}">{{isBuyNow ? SCData?.PersonalDetailsTitle :
      apiDomain ? "Get Pre-Qualified in Minutes" : SCData?.PreQualTitle}}</h1>
    <div class="prequal-subtitle-t3 an-p-line-height" *ngIf="apiDomain">
      There’s no impact to your credit score!
    </div>
    <div class="secure-text-box" [ngClass]="{'secure-text-box-t3' : apiDomain}">
      

      <svg *ngIf="!apiDomain" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Icon" clip-path="url(#clip0_225_674)">
        <g id="Lock">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 5.87921C2.15482 5.87921 1.875 6.15903 1.875 6.50421V10.0042C1.875 10.3494 2.15482 10.6292 2.5 10.6292H9.5C9.84518 10.6292 10.125 10.3494 10.125 10.0042V6.50421C10.125 6.15903 9.84518 5.87921 9.5 5.87921H2.5ZM1.125 6.50421C1.125 5.74482 1.74061 5.12921 2.5 5.12921H9.5C10.2594 5.12921 10.875 5.74482 10.875 6.50421V10.0042C10.875 10.7636 10.2594 11.3792 9.5 11.3792H2.5C1.74061 11.3792 1.125 10.7636 1.125 10.0042V6.50421Z" fill="var(--text-heading)"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 1.37921C5.43641 1.37921 4.89591 1.60309 4.4974 2.00161C4.09888 2.40012 3.875 2.94063 3.875 3.50421V5.50421C3.875 5.71132 3.70711 5.87921 3.5 5.87921C3.29289 5.87921 3.125 5.71132 3.125 5.50421V3.50421C3.125 2.74171 3.4279 2.01045 3.96707 1.47128C4.50624 0.932112 5.2375 0.629211 6 0.629211C6.7625 0.629211 7.49376 0.932112 8.03293 1.47128C8.5721 2.01045 8.875 2.74171 8.875 3.50421V5.50421C8.875 5.71132 8.70711 5.87921 8.5 5.87921C8.29289 5.87921 8.125 5.71132 8.125 5.50421V3.50421C8.125 2.94063 7.90112 2.40012 7.5026 2.00161C7.10409 1.60309 6.56359 1.37921 6 1.37921Z" fill="var(--text-heading)"/>
        </g>
        </g>
        <defs>
        <clipPath id="clip0_225_674">
        <rect width="12" height="12" fill="white" transform="translate(0 0.00421143)"/>
        </clipPath>
        </defs>
        </svg>
 <svg  *ngIf="apiDomain" xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.58961 8.82387C3.1023 8.82387 2.70726 9.21892 2.70726 9.70623V14.6474C2.70726 15.1347 3.1023 15.5298 3.58961 15.5298H13.472C13.9593 15.5298 14.3543 15.1347 14.3543 14.6474V9.70623C14.3543 9.21892 13.9593 8.82387 13.472 8.82387H3.58961ZM1.64844 9.70623C1.64844 8.63414 2.51753 7.76505 3.58961 7.76505H13.472C14.5441 7.76505 15.4131 8.63414 15.4131 9.70623V14.6474C15.4131 15.7195 14.5441 16.5886 13.472 16.5886H3.58961C2.51753 16.5886 1.64844 15.7195 1.64844 14.6474V9.70623Z" fill="var(--grayscale-800)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.53079 2.47093C7.73514 2.47093 6.97208 2.787 6.40947 3.34961C5.84686 3.91222 5.53079 4.67528 5.53079 5.47093V8.29446C5.53079 8.58685 5.29376 8.82387 5.00138 8.82387C4.70899 8.82387 4.47197 8.58685 4.47197 8.29446V5.47093C4.47197 4.39447 4.89959 3.36209 5.66077 2.60091C6.42195 1.83973 7.45432 1.41211 8.53079 1.41211C9.60726 1.41211 10.6396 1.83973 11.4008 2.60091C12.162 3.36209 12.5896 4.39447 12.5896 5.47093V8.29446C12.5896 8.58685 12.3526 8.82387 12.0602 8.82387C11.7678 8.82387 11.5308 8.58685 11.5308 8.29446V5.47093C11.5308 4.67528 11.2147 3.91222 10.6521 3.34961C10.0895 2.787 9.32644 2.47093 8.53079 2.47093Z" fill="var(--grayscale-800)"/>
</svg>
      <span class="secure-text-msg" [ngClass]="{'secure-text-msg-t3' : apiDomain}" >{{apiDomain ? "Secure Application" : "Information submitted securely."}}</span></div>
  
    <form novalidate [formGroup]="preQualForm" class="col-12 p-1 scrollDiv prequalForm" [ngClass]="{'legacy-prequal-form':  isLegacyCreditApp, 'prequal-t3-form' : apiDomain}">
      <div class="row m-0 preQualFormRow">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 rail leftRail" [ngClass]="{'bb-none': isBuyNow}">
          <!-- Start if First Name-->
          <div class="row mx-0 form-row w-100">
            <div class="col-8 pr-3">
              <label class="text-dark-gray" [ngClass]="{'legacy-prequal-text-dark-gray':  isLegacyCreditApp}" for="first_name">{{ SCData?.FirstName }}<span aria-hidden="true"
                  class="asterisk-pink">*</span></label>
              <input id="first_name" class="form-control w-100" formControlName="FirstName" maxlength="32" type="text"
                autocomplete="first_name" (focus)="preQualForm.get('FirstName').markAsUntouched();firstname.focus()"
                #firstname [ngClass]="{
                error:
                  (preQualForm.get('FirstName').touched ||
                    preQualForm.get('FirstName').dirty) &&
                  !preQualForm.get('FirstName').valid
              }" />
              <div class="invalid-feedback error-width-for-half-row d-flex"
                (click)="preQualForm.get('FirstName').markAsUntouched();firstname.focus()"
                *ngIf="!hasFocus(firstname) && preQualForm.get('FirstName').touched  && !preQualForm.get('FirstName').valid">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('FirstName').errors?.required; else second">
                    {{ SCData?.FirstNameRequiredError }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!!preQualForm.get('FirstName').errors?.minlength; else third">
                      {{ SCData?.FirstNameInvalidError }}
                    </ng-container>
                    <ng-template #third>
                      <ng-container *ngIf="!!preQualForm.get('FirstName').errors?.pattern">
                        {{ SCData?.FirstNameInvalidError }}
                      </ng-container>
                    </ng-template>
                  </ng-template>
                </span>
              </div>
            </div>

            <div class="col-4">
              <label for="MiddleName" class="mi-label" autocomplete="additional-name"
                aria-label="Middle Name (Optional)">{{SCData?.MiddleName}}</label>
              <input class="form-control w-100" name="MI" formControlName="MI" maxlength="1" type="text" #mi
                id="MiddleName" [ngClass]="{
                error:
                  (preQualForm.get('MI').touched ||
                  preQualForm.get('MI').dirty) &&
                  !preQualForm.get('MI').valid
              }" />
              <div class="invalid-feedback d-flex" (click)="preQualForm.get('MI').markAsUntouched();mi.focus()"
                *ngIf="!hasFocus(mi) && preQualForm.get('MI').touched  && !preQualForm.get('MI').valid">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('MI').errors?.required; else second">
                    {{ SCData?.MIInvalid }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!!preQualForm.get('MI').errors?.minlength; else third">
                      {{ SCData?.MIInvalid }}
                    </ng-container>
                    <ng-template #third>
                      <ng-container *ngIf="!!preQualForm.get('MI').errors?.pattern">
                        {{ SCData?.MIInvalid }}
                      </ng-container>
                    </ng-template>
                  </ng-template>
                </span>
              </div>
            </div>

          </div>
          <!-- end of First name and Start of Last Name-->
          <div class="row mx-0 form-row w-100">
            <div class="col-12">
              <label class="text-dark-gray" for="lastNameId">{{ SCData?.LastName }}<span aria-hidden="true"
                  class="asterisk-pink">*</span></label>
              <input class="form-control w-100 pr-5" maxlength="65" id="lastNameId"
                (focus)="preQualForm.get('LastName').markAsUntouched();lastname.focus()" type="text"
                autocomplete="family-name" formControlName="LastName" #lastname [ngClass]="{
                error:
                  (preQualForm.get('LastName').touched ||
                    preQualForm.get('LastName').dirty) &&
                  !preQualForm.get('LastName').valid
              }" />

              <div class="invalid-feedback error-width-for-full-row d-flex"
                (click)="preQualForm.get('LastName').markAsUntouched();lastname.focus()"
                *ngIf="!hasFocus(lastname) && preQualForm.get('LastName').touched  && !preQualForm.get('LastName').valid">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('LastName').errors?.required; else second">
                    {{ SCData?.LastNameRequiredError }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!!preQualForm.get('LastName').errors?.minlength; else third">
                      {{ SCData?.LastNameInvalidError }}
                    </ng-container>
                    <ng-template #third>
                      <ng-container *ngIf="!!preQualForm.get('LastName').errors?.pattern">
                        {{ SCData?.LastNameInvalidError }}
                      </ng-container>
                    </ng-template>
                  </ng-template>
                </span>
              </div>
            </div>
          </div>
          <!--end of last name and start of last name-->
          <div class="row mx-0 form-row w-100">
            <div class="col-12">
              <label class="text-dark-gray" for="email">{{ SCData?.Email }}<span aria-hidden="true"
                  class="asterisk-pink">*</span>
                  <span class="email-tooltip" *ngIf="isLoggedIn && config?.Sitecore?.PreQualLeadInfo?.email">
                    <span class="feature-text" id="emailTooltip-Content">
                      <span class="tooltiptext" id="emailTooltip">Forms submitted while you are logged in are tied to your account. If you would like to change the email address used in this form, please log out and try again.</span>
                      <span class="tooltipx dt-icon dt-icon-question-mark vhtooltip-style"></span>
                    </span>
                  </span>
                </label>
              <input class="form-control w-100 pr-2" type="text" formControlName="Email" id="email" autocomplete="email"
                (focus)="preQualForm.get('Email').markAsUntouched();email.focus()" maxlength="40" #email [ngClass]="{
                error:
                  (preQualForm.get('Email').touched ||
                    preQualForm.get('Email').dirty) &&
                  !preQualForm.get('Email').valid
              }" [attr.disabled]="disableEmailFieldFn" [readonly]="isLoggedIn && config?.Sitecore?.PreQualLeadInfo?.email"/>
              <div class="invalid-feedback error-width-for-full-row d-flex" (click)="preQualForm.get('Email').markAsUntouched();email.focus()"
                *ngIf="!hasFocus(email) && preQualForm.get('Email').touched  && !preQualForm.get('Email').valid">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('Email').errors?.required; else second">
                    {{ SCData?.EmailRequiredError }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="preQualForm.get('Email').errors?.apiInvalid; else third">
                      Please use a valid email.
                    </ng-container>
                    <ng-template #third>
                      <ng-container *ngIf="!preQualForm.get('Email').valid">
                        {{ SCData?.EmailInvalidError }}
                      </ng-container>
                    </ng-template>
                  </ng-template>
                </span>
              </div>
            </div>
          </div>
          <!--end of Email and start if phone and zipcode-->
          <div class="row mx-0 form-row w-100">
            <div class="col-8 pr-3">
              <label class="text-dark-gray" for="phone">{{ SCData?.Phone }}<span aria-hidden="true"
                  class="asterisk-pink">*</span></label>
              <input class="form-control w-100" formControlName="Phone" id="phone" autocomplete="phone" #phone
                (focus)="preQualForm.get('Phone').markAsUntouched();phone.focus()" type="text"
                placeholder="(___)___-____" [dtTextMask]="{ mask: phoneMask, guide: true }" [ngClass]="{
                error:
                  (preQualForm.get('Phone').touched ||
                    preQualForm.get('Phone').dirty) &&
                  (!!preQualForm.get('Phone').invalid || !!preQualForm.get('Phone').errors?.invalidAreaCode)
              }" />
              <div class="invalid-feedback error-width-for-half-row d-flex" (click)="preQualForm.get('Phone').markAsUntouched();phone.focus()"
                *ngIf="!hasFocus(phone) && preQualForm.get('Phone').touched  && !preQualForm.get('Phone').valid">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('Phone').errors?.required; else second">
                    {{ SCData?.PhoneRequiredError }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="preQualForm.get('Phone').errors?.apiInvalid; else third">
                      Please use a valid phone number.
                    </ng-container>
                  </ng-template>
                  <ng-template #third>
                    <ng-container *ngIf="preQualForm.get('Phone').errors?.invalidAreaCode; else fourth">
                      {{ SCData?.PhoneInvalidAreaCode }}
                    </ng-container>
                  </ng-template>
                  <ng-template #fourth>
                    <ng-container *ngIf="!preQualForm.get('Phone').valid">
                      {{ SCData?.PhoneInvalidError }}
                    </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>

            <div class="col-4">
              <label class="text-dark-gray" for="zip_code">{{ SCData?.Zipcode }}<span aria-hidden="true"
                  class="asterisk-pink">*</span></label>
              <div class="mr-lg-0">
                <input class="form-control w-100 pr-5" id="zip_code" autocomplete="postal-code" #Zipcode
                  (focus)="preQualForm.get('Zipcode').markAsUntouched();Zipcode.focus()" formControlName="Zipcode"
                  [ngClass]="{'error': !preQualForm.get('Zipcode').valid &&
                          (preQualForm.get('Zipcode').touched ||
                          preQualForm.get('Zipcode').dirty ||
                          (formSubmitAttempt)) }" type="text" [dtTextMask]="{ mask: zipCodeMask, guide:false }" />
                <a *ngIf="!isBuyNow && !apiDomain" href="javascript:void(0);" class="locateMeButton" (click)="getBrowserZipcode()">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13" height="14" viewBox="0 0 13 14"><defs><style>.a{fill:none;}.b{clip-path:url(#a);}.c{fill:var(--pink-600);}</style><clipPath id="a"><path class="a" d="M0,0H13V14H0Z"/></clipPath></defs><path class="a" d="M0,0H13V14H0Z"/><g class="b"><path class="c" d="M9.072,14a.459.459,0,0,1-.462-.433L6.73,8.626a.462.462,0,0,0-.438-.3H6.268L.525,8.485a.475.475,0,0,1-.061,0,.467.467,0,0,1-.422-.265.444.444,0,0,1-.014-.345A.454.454,0,0,1,.27,7.622L12.261.077A.473.473,0,0,1,12.515,0V.027h.023a.467.467,0,0,1,.139.021.457.457,0,0,1,.273.227.443.443,0,0,1,.029.343L9.535,13.522a.446.446,0,0,1-.115.324A.463.463,0,0,1,9.1,14ZM6.254,7.231H6.3a1.584,1.584,0,0,1,1.472,1l1.2,3.157,2.55-9.571.005,0L2.732,7.331Z"/></g></svg>
                </a>
                <div class="invalid-feedback error-width-for-half-row d-flex"
                  (click)="preQualForm.get('Zipcode').markAsUntouched();Zipcode.focus()"
                  *ngIf="!hasFocus(Zipcode) && preQualForm.get('Zipcode').touched  && !preQualForm.get('Zipcode').valid">
                  <span class="form-validator_error" role="alert">
                    <ng-container *ngIf="!!preQualForm.get('Zipcode').errors?.required; else second">
                      {{ SCData?.ZipCodeRequiredError }}
                    </ng-container>
                    <ng-template #second>
                      <ng-container *ngIf="!preQualForm.get('Zipcode').valid">
                        {{ SCData?.ZipCodeInvalidError }}
                      </ng-container>
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 rail rightRail">

          <div class="row mx-0 form-row mb-8 w-100"
            *ngIf="isBuyNow && config.Sitecore.CreditApplicationConfig.PreQualificationInformation.BuyNowHomeDeliveryEnable">
            <div class="col-12">
              <div class="custom-checkbox d-flex align-items-center">
                <input type="checkbox" value="answer" id="isHomeDelivery" formControlName="HomeDelivery" tabindex="-1">
                <label for="isHomeDelivery" class="isHomeDelivery w-auto" tabindex="0" (keyup)="
              $event.keyCode === 13 || $event.keyCode ===32
                ? preQualForm.get('HomeDelivery').setValue(!preQualForm.get('HomeDelivery').value)
                : null
            ">
                  {{SCData?.HomeDeliveryText}}
                  <img [src]="SCData?.StoreToDoorLogo?.Src">
                </label>
                <span class="dt-icon dt-icon-question-mark dt-question-mark-tooltip tooltip-container">
                  <div _ngcontent-vxi-c21="" class="feature-text">
                    <span _ngcontent-vxi-c21="" class="tooltiptext">{{SCData?.HomeDeliveryTooltip}}</span>
                  </div>
                </span>
              </div>
            </div>
          </div>

          <div class="row mx-0 form-row mb-7 w-100"
            *ngIf="isBuyNow && config.Sitecore.CreditApplicationConfig.PreQualificationInformation.BuyNowPreQualEnable">
            <div class="col-12">
              <div class="custom-checkbox d-flex">
                <input type="checkbox" id="isPreQualification" formControlName="PreQualiFyMe" tabindex="-1">
                <label for="isPreQualification" class="isPreQualification w-auto ada-cursor" tabindex="0" (keyup)="
              $event.keyCode === 13 || $event.keyCode ===32
                ? preQualForm.get('PreQualiFyMe').setValue(!preQualForm.get('PreQualiFyMe').value)
                : null
            ">
                  {{SCData?.PreQualText}}
                </label>
                <span
                  class="dt-icon dt-icon-question-mark dt-question-mark-tooltip tooltip-container preQualification-tooltip">
                  <div _ngcontent-vxi-c21="" class="feature-text">
                    <span _ngcontent-vxi-c21="" class="tooltiptext">{{SCData?.PreQualTooltip}}</span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <!--Start of Address Field -->

          <div class="row mx-0 form-row w-100" [hidden]="!isHomeDelivery && !preQualiFyMe && isBuyNow">
            <div class="col-12" id='searchBoxContainer'>
              <label class="text-dark-gray" for="Address">{{ SCData?.Address }}<span aria-hidden="true"
                  class="asterisk-pink">*</span></label>
              <input class="form-control w-100 pr-5" id="Address" formControlName="Address" autocomplete="address"
                type="text" (focus)="preQualForm.get('Address').markAsUntouched();address.focus()" maxlength="50"
                #address [ngClass]="{'error': !preQualForm.get('Address').valid &&
                      (preQualForm.get('Address').touched ||
                        preQualForm.get('Address').dirty ||
                        (formSubmitAttempt)) }" />
              <div class="invalid-feedback error-width-for-full-row d-flex"
                (click)="preQualForm.get('Address').markAsUntouched();address.focus()"
                *ngIf="!hasFocus(address) && !preQualForm.get('Address').valid && preQualForm.get('Address').touched">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('Address').errors?.required; else second">
                    {{ SCData?.AddressRequiredError }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!!preQualForm.get('Address').errors?.minlength; else third">
                      {{ SCData?.AddressInvalidError }}
                    </ng-container>
                    <ng-template #third>
                      <ng-container *ngIf="!!preQualForm.get('Address').errors?.pattern">
                        {{ SCData?.AddressInvalidError }}
                      </ng-container>
                    </ng-template>
                  </ng-template>
                </span>
              </div>
            </div>
          </div>
          <!-- End of Address Field Start of city Field and state-->

          <!--Start of Address2 Field -->

          <div class="row mx-0 form-row w-100" [hidden]="!isHomeDelivery && !preQualiFyMe && isBuyNow">
            <div class="col-12">
              <label class="text-dark-gray" for="Address2">{{ SCData?.Address2 }}</label>
              <input class="form-control w-100 pr-5" id="Address2" formControlName="Address2" autocomplete="address2"
                type="text" (focus)="preQualForm.get('Address2').markAsUntouched();address2.focus()" maxlength="50"
                #address2 [ngClass]="{'error': !preQualForm.get('Address2').valid &&
                      (preQualForm.get('Address2').touched ||
                        preQualForm.get('Address2').dirty ||
                        (formSubmitAttempt)) }" />
              <div class="invalid-feedback error-width-for-full-row d-flex"
                (click)="preQualForm.get('Address2').markAsUntouched();address2.focus()"
                *ngIf="!hasFocus(address2) && !preQualForm.get('Address2').valid && preQualForm.get('Address2').touched">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('Address2').errors?.pattern">
                    {{ SCData?.Address2InvalidError }}
                  </ng-container>
                </span>
              </div>
            </div>
          </div>
          <!-- End of Address2 Field Start of city Field and state-->

          <div class="row mx-0 form-row w-100" [hidden]="!isHomeDelivery && !preQualiFyMe && isBuyNow">

            <div class="col-7 pr-3">
              <label class="text-dark-gray" for="city">{{SCData?.City }}<span aria-hidden="true"
                  class="asterisk-pink">*</span></label>
              <input class="form-control w-100 pr-2" id="city" formControlName="City" autocomplete="home city"
                type="text" (focus)="preQualForm.get('City').markAsUntouched();city.focus()" maxlength="38" #city
                [ngClass]="{'error': !preQualForm.get('City').valid &&
                                              (preQualForm.get('City').touched ||
                                                preQualForm.get('City').dirty ||
                                                (formSubmitAttempt)) }" />
              <div class="invalid-feedback error-width-for-half-row d-flex" (click)="preQualForm.get('City').markAsUntouched();city.focus()"
                *ngIf="!hasFocus(city) && !preQualForm.get('City').valid && (preQualForm.get('City').touched)">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('City').errors?.required; else second">
                    {{ SCData?.CityRequiredError }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!!preQualForm.get('City').errors?.pattern">
                      {{ SCData?.CityInvalidError }}
                    </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>

            <div class="col-5">
              <label class="text-dark-gray" for="state">{{ SCData?.State }}<span aria-hidden="true"
                  class="asterisk-pink">*</span></label>
              <select class="form-control w-100 gradient ada-cursor" id="state" #state formControlName="State" [ngClass]="{'error': !preQualForm.get('State').valid &&
                                              (formSubmitAttempt ||
                                                (preQualForm.get('State').touched
                                                    || preQualForm.get('State').dirty)) }">
                <option value="" [selected]="preQualForm.get('State').value === '' ||
                                            preQualForm.get('State').value === null">
                  {{ creditAppConfigData?.SelectsDefaultLabel }}
                </option>
                <option *ngFor="let state of states" [value]="state.Value"
                  [selected]="state.Value === preQualForm.get('State').value">
                  {{ state?.Description }}
                </option>
              </select>
              <div class="invalid-feedback error-width-for-half-row d-flex" (click)="preQualForm.get('State').markAsUntouched();state.focus()"
                *ngIf="!hasFocus(state) && !preQualForm.get('State').valid && (preQualForm.get('State').touched)">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('State').errors?.required">
                    {{ SCData?.StateRequiredError }}
                  </ng-container>
                </span>
              </div>
            </div>

          </div>

          <!-- End of city , state and start of birthdate and SSN-->
          <!-- <div class="row mx-0 form-row w-100" *ngIf="preQualiFyMe || !isBuyNow"> -->
          <div *ngIf="!config.Sitecore.isLegacyCreditApp" class="row mx-0 form-row w-100 ssn-container"
            [hidden]="!isHomeDelivery && !preQualiFyMe && isBuyNow">
            <!-- *************************** DOB Start ***************************  -->
            <div
              [ngClass]="{'col-6 ':!isOrStandAlonePreQual, 'pr-3': !isOrStandAlonePreQual, 'col-5 ':isOrStandAlonePreQual}"
              *ngIf="showBirthDate && IsDisplayDOBPrequal">
              <label class="text-dark-gray" for="dob" [attr.aria-label]="SCData?.DateofBirth + ' (MM/DD/YYYY)'">
                {{SCData?.DateofBirth}}<span *ngIf="isBuyNow || !isOrStandAlonePreQual" aria-hidden="true" class="asterisk-pink">*</span>
              </label>
              
              <input type="text" class="form-control w-100" formControlName="DOB" autocomplete="bday"
                (focus)="preQualForm.get('DOB').markAsUntouched();dateofbirth.focus()" id="dob" placeholder="MM/DD/YYYY"
                (change)="validateDOB()" #dateofbirth [ngClass]="{
                error:
                  (preQualForm.get('DOB').touched ||
                    preQualForm.get('DOB').dirty) &&
                  (!!preQualForm.get('DOB').invalid || !!preQualForm.get('DOB').errors?.invalidDOB)
              }" [dtTextMask]="{ mask: dobMask, guide: true }" />
              <div class="invalid-feedback error-width-for-half-row d-flex"
                (click)="preQualForm.get('DOB').markAsUntouched();dateofbirth.focus()"
                *ngIf="!hasFocus(dateofbirth) && preQualForm.get('DOB').touched && !preQualForm.get('DOB').valid">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('DOB').errors?.required; else second">
                    {{ SCData?.DOBRequiredError }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container>
                      {{ SCData?.DateOfBirthInvalidError }}
                    </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>
            <!-- *************************** DOB End ***************************  -->
            <div class="col-1 orpipediv" *ngIf="isOrStandAlonePreQual && !config.Sitecore.isLegacyCreditApp">
              <label class="text-dark-gray orpipelabel">| <span class="orpipeText">{{ SCData?.IsORLabel }} <span aria-hidden="true"
                class="asterisk-pink">*</span></span>  |</label>
            </div>
            <!-- *************************** SSN Start ***************************  -->
            <div class="col-6" *ngIf="showSSN && IsDisplaySSNPrequal && !config.Sitecore.isLegacyCreditApp">
              <label class="text-dark-gray" for="ssn"> 
                {{SCData?.SSN}} <span *ngIf="isBuyNow || !isOrStandAlonePreQual" aria-hidden="true" class="asterisk-pink">*</span>
              </label>
              <input #ssnInput2 [type]="ssnflag || !IE ? 'text' : 'password'" class="form-control w-100"
                formControlName="SSN" autocomplete="SSN" #ssn id="ssn" autocomplete="off" (change)="validateSSN()"
                (focus)="checkSecureSSN(false)" placeholder="___-__-____" [ngClass]="{
              error:
                (preQualForm.get('SSN').touched ||
                  preQualForm.get('SSN').dirty) &&
                (!preQualForm.get('SSN').valid || !!preQualForm.get('SSN').errors?.inValidSSN)
              ,'ssn-custom-mask': !ssnflag && !IE}" [dtTextMask]="{ mask: ssnMask, guide: ssnflag }" />
              <button tabindex="0" class="form-icon-eye dt-icon" *ngIf="!isBuyNow"
                [ngClass]="{'dt-icon-eye-open ' : ssnflag, 'dt-icon-eye-close ' : !ssnflag, 'iconEyePositionStandAlone ': IsStandAlonePreQual, 'iconEyePositionStandAloneNot ': !IsStandAlonePreQual}"
                (click)="checkSecureSSN(true);toggleAriaPress($event);preQualForm.get('SSN').markAsUntouched();ssn.focus();"
                (keyup)="$event?.keyCode ===  13 ? checkSecureSSN(true) : null" tabindex="0" aria-pressed="false"
                aria-label="View SSN">
              </button>
              <button tabindex="0" class="form-icon-eye dt-icon buynow"
                [ngClass]="ssnflag ? 'dt-icon-eye-open' : 'dt-icon-eye-close'" (click)="checkSecureSSN(true)"
                *ngIf="isBuyNow" (keyup)="$event?.keyCode ===  13 ? checkSecureSSN(true): null">
              </button>
              <div class="invalid-feedback error-width-for-half-row d-flex" (click)="preQualForm.get('SSN').markAsUntouched();ssn.focus()"
                *ngIf="!hasFocus(ssn) && preQualForm.get('SSN').touched  && !preQualForm.get('SSN').valid">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('SSN').errors?.required; else second">
                    {{ SCData?.SSNRequiredError }}
                  </ng-container>
                  <ng-template #second>
                    <ng-container *ngIf="!!preQualForm.get('SSN').errors?.pattern; else invalidTemplate">
                      {{ IsStandAlonePreQual ? this.SCData?.SSNStandAloneErrormessage : SCData?.SSNInvalidError }}
                    </ng-container>
                    <ng-template #invalidTemplate>
                      <!-- {{ SCData?.Ssn1invalid }} -->
                      SSN is invalid
                    </ng-template>
                  </ng-template>
                </span>
              </div>
            </div>
            <!-- *************************** SSN Start ***************************  -->
          </div>
          <!-- end of birthdate and ssn , start of mortgage/rent -->
           <!-- *************************** mortgage/rent Start ***************************  -->
           <div [hidden]="!preQualiFyMe && isBuyNow" class="row mx-0 form-row w-100 mortgage-income-row">
            <div class="mortgage-input" [ngClass]="!isBuyNow && !isLegacyCreditApp ? 'col-5' : 'col-6 pr-3'">
              <label class="text-dark-gray w-100" for="MortgageRent"> 
                <div class="label-text">
                  <span>{{SCData?.MortgageRent}}</span><span aria-hidden="true"class="asterisk-pink">*</span>
                </div>
                
                <div class="tool-tip-container">
                  <an-tooltip
                    [tooltipTitle]="SCData?.MortgageRent" 
                    [tooltipContent]="SCData?.MortgageRentTooltip" 
                    [tooltipMarginLeft]="isTabletView ? '-22px' : '-275px'" 
                    tooltipMarginBottom="3px"
                    [tooltipWith]="isTabletView ? '220px': '328px'"
                    [tooltipArrowMarginLeft]="isTabletView ? '-100px' : '110px'">
                    <a href="javascript:void(0)" class="tooltip-icon"></a>
                  </an-tooltip>
                </div>
              </label>
              
              <input #MortgageRent type="text" class="form-control w-100"
                usdOnly
                (focus)="preQualForm.get('MortgageRent').markAsUntouched()"
                formControlName="MortgageRent" maxlength="7"  id="MortgageRent" MortgageRent
                [ngClass]="{
              error:
                (preQualForm.get('MortgageRent').touched ||
                  preQualForm.get('MortgageRent').dirty) &&
                (!preQualForm.get('MortgageRent').valid)}"/>
  
              <div class="invalid-feedback error-width-for-half-row d-flex" (click)="preQualForm.get('MortgageRent').markAsUntouched();MortgageRent.focus()"
                *ngIf="!hasFocus(MortgageRent) && preQualForm.get('MortgageRent').touched  && !preQualForm.get('MortgageRent').valid">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('MortgageRent').errors?.required; else invalidTemplate">
                    {{ SCData?.MortgageRentRequiredError }}
                  </ng-container>
                  <ng-template #invalidTemplate>
                    {{ SCData?.MortgageRentInvalidError }}
                  </ng-template>
                </span>
              </div>
            </div>
            <div *ngIf="!isBuyNow && !isLegacyCreditApp" class="col-1"></div>
            <div class="col-6">
              <label class="text-dark-gray w-100 annual-income-label" for="AnnualIncome"> 
                <div class="label-text">
                  <span>{{SCData?.AnnualIncome}}</span><span aria-hidden="true"class="asterisk-pink">*</span>
                </div>
                <div class="tool-tip-container">
                  <an-tooltip class="float-right" 
                    [tooltipTitle]="SCData?.AnnualIncome" 
                    [tooltipContent]="SCData?.AnnualIncomeTooltip" 
                    [tooltipMarginLeft]="isTabletView ? '-275px' : '-320px'" 
                    tooltipMarginBottom="3px"
                    [tooltipWith]="isTabletView ? '280px': '328px'"
                    [tooltipArrowMarginLeft]="isTabletView ? '128px': '145px'">
                    <a href="javascript:void(0)" class="tooltip-icon"></a>
                  </an-tooltip>
                </div>
                
              </label>
              <input #AnnualIncome type="text" class="form-control w-100"
                usdOnly
                (focus)="preQualForm.get('AnnualIncome').markAsUntouched()"
                formControlName="AnnualIncome" maxlength="12"  id="AnnualIncome" AnnualIncome
                [ngClass]="{
              error:
                (preQualForm.get('AnnualIncome').touched ||
                  preQualForm.get('AnnualIncome').dirty) &&
                (!preQualForm.get('AnnualIncome').valid)}"/>
  
              <div class="invalid-feedback error-width-for-half-row d-flex" (click)="preQualForm.get('AnnualIncome').markAsUntouched();AnnualIncome.focus()"
                *ngIf="!hasFocus(AnnualIncome) && preQualForm.get('AnnualIncome').touched  && !preQualForm.get('AnnualIncome').valid">
                <span class="form-validator_error" role="alert">
                  <ng-container *ngIf="!!preQualForm.get('AnnualIncome').errors?.required; else invalidTemplate">
                    {{ SCData?.AnnualIncomeRequiredError }}
                  </ng-container>
                  <ng-template #invalidTemplate>
                    {{ SCData?.AnnualIncomeInvalidError }}
                  </ng-template>
                </span>
              </div>
            </div>
           </div>
          <!-- ***************************End of mortgage/rent and start Annual Income ***************************  -->
            <!-- ***************************  Annual Income Start ***************************  -->
            <div [hidden]="!isHomeDelivery && !preQualiFyMe && isBuyNow" class="row mx-0 form-row w-100">
              
             </div>
            <!-- ***************************End of mortgage/rent ***************************  -->
        </div>
      </div>
    </form>
     <!-- ***************************Start of disclaimer ***************************  -->
    <div class="row mx-0 form-row disclaimer-row an-p-line-height" [ngClass]="{'legacy-prequal-disclaimer-form':  isLegacyCreditApp, 'prequal-t3-disclaimer-form' : apiDomain}"
         *ngIf="IsStandAlonePreQual ? IsStandAlonePreQual : (preQualiFyMe || !isBuyNow)" [innerHTML]="apiDomain ? sanitizer.bypassSecurityTrustHtml(t3Disclaimer) : IsStandAlonePreQual ? sanitizer.bypassSecurityTrustHtml(StandalonePreQualDisclaimer) : sanitizer.bypassSecurityTrustHtml(SCData?.PreQualDisclaimer)">
    </div>

    <div class="col-12 p-0 d-flex cta-col" *ngIf="!IsStandAlonePreQual && !isBuyNow">
      <button id="back_cta" type="button" [disabled]="!preQualForm.valid" class="secondary-cta ml-auto"
        (click)="submitPreQualApplication()">
        {{ SCData?.IAgreeCTA}}
      </button>
    </div>



    <div class="col-12 d-flex cta-col cta-section m-0 prequal-next-ctacheck" *ngIf="IsStandAlonePreQual && !isBuyNow &&  !config.Sitecore.isLegacyCreditApp">
      <div class="w-100 ml-auto d-flex cta-alignment">
        <button id="next_cta" type="button" [disabled]="!preQualForm.valid || submitClicked" class="primary-cta ml-auto"
        [ngClass]="{'prequal-t3-btn' : apiDomain}"
          (click)="submitPreQualApplication()">
          {{ apiDomain ? "Get Prequalified" : SCData?.NextCta}}
        </button>
      </div>
    </div>

    <div class="col-12 d-flex cta-col cta-section m-0" *ngIf="isBuyNow">
      <div class="w-100 ml-auto d-flex cta-alignment">
        <button id="next_cta" type="button" [attr.disabled]="!preQualForm.valid || submitClicked ? true : null"
          class="primary-cta ml-auto" [ngClass]="{'prequal-t3-btn' : apiDomain}" (click)="submitPreQualApplication()">
          {{ apiDomain ? "Get Prequalified" : SCData?.NextCta}}
        </button>
      </div>
    </div>
  </div>
  <dt-prequal-result class="row m-0 prequal-info d-block" *ngIf="showConfirmation" [outcome]="outcome"
    (back)=backClicked($event)></dt-prequal-result>
</div>
<div class="col-12 d-flex cta-col cta-section m-0 prequal-next-ctacheck legacy-credit-next-cta" *ngIf="IsStandAlonePreQual && !isBuyNow && config.Sitecore.isLegacyCreditApp">
  <div class="w-100 ml-auto d-flex cta-alignment">
    <button id="next_cta" type="button" [disabled]="!preQualForm.valid || submitClicked || !isEnableNextFlag" class="primary-cta ml-auto"
    [ngClass]="{'prequal-t3-btn' : apiDomain}"
      (click)="submitPreQualApplication()">
      {{ apiDomain ? "Get Prequalified" : SCData?.NextCta}}
    </button>
  </div>
</div>
<div class="dt-modal-content anx-body" *ngIf="!isPrequalANXEnabled && !isBuyNow">
  <div class="anx-jacked-body row">
    <span class="anx-jacked-image" [innerHTML]="creditAppConfigData?.JackedImage | ANSafeHtml"></span>
    <span class="anx-jacked-title">{{ creditAppConfigData?.JackedTitle }}</span>
    <span class="anx-jacked-subtitle">{{ creditAppConfigData?.JackedMessage }} </span>
  </div>
</div>
<div class="dt-modal" tabindex="-1" role="dialog" *ngIf="showJackedModal" (click)="closeJacked()">
  <div class="dt-modal-dialog pqrj" role="document">
    <div class="dt-modal-content">
      <div class="close-modal " data-dismiss="modal">
        <div class="close-x" (click)="closeJacked()">
          <img type="image/svg+xml" alt="close"
            src="data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%2017%2017%22%3Ea%20%20%3Cdefs%3E%20%3Cstyle%3E.clsa%2C.clsc%7Bfill%3A%230A3453%3B%7D.clsa%7Bclip-rule%3Aevenodd%3B%7D.clsb%7Bclip-path%3Aurl%28%23clsa%29%3B%7D.clsd%7Bclip-path%3Aurl%28%23clsb%29%3B%7D%20%3C%2Fstyle%3E%20%3CclipPath%20id%3D%22clsa%22%3E%3Cpath%20class%3D%22clsa%22%20d%3D%22M1.495-16.278%2C17.722-.051l-.773.773L.722-15.505Z%22%20transform%3D%22translate%28-0.722%2016.278%29%22%20%2F%3E%20%3C%2FclipPath%3E%20%3CclipPath%20id%3D%22clsb%22%3E%3Cpath%20class%3D%22clsa%22%20d%3D%22M16.949-16.278l.773.773L1.495.722.722-.051Z%22%20transform%3D%22translate%28-0.722%2016.278%29%22%20%2F%3E%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20transform%3D%22translate%28-0.722%2016.278%29%22%3E%20%3Cg%20class%3D%22clsb%22%20transform%3D%22translate%280.722%20-16.278%29%22%3E%3Cpath%20class%3D%22clsc%22%20d%3D%22M2.151-23.349%2C26.105.605l-8.5%2C8.5L-6.349-14.849Z%22%20transform%3D%22translate%28-1.378%2015.622%29%22%20%2F%3E%20%3C%2Fg%3E%20%3Cg%20class%3D%22clsd%22%20transform%3D%22translate%280.722%20-16.278%29%22%3E%3Cpath%20class%3D%22clsc%22%20d%3D%22M17.605-23.349l8.5%2C8.5L2.151%2C9.105l-8.5-8.5Z%22%20transform%3D%22translate%28-1.378%2015.622%29%22%20%2F%3E%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%20%3C%2Fsvg%3E">
        </div>
      </div>
      <div class="modal-body">
        <div class="jacked-body row">
          <span class="jacked-image" [innerHTML]="creditAppConfigData?.JackedImage | ANSafeHtml"></span>
          <span class="jacked-title">{{ creditAppConfigData?.JackedTitle }}</span>
          <span class="jacked-subtitle">{{ creditAppConfigData?.JackedMessage }} </span>
          <span class="jacked-buttons">
            <button class="secondary-cta ml-auto" (click)="closeJacked()">{{ creditAppConfigData?.JackedCTA }}</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<div  *ngIf="IsStandAlonePreQual && !isBuyNow && preQualLeadInfo.leadid == 0 && openLowerPriceModal && !isLowerpriceModalEnabledFlag">
  <lead-form-modal [openOnLinkCLick]="openLowerPriceModal" [leadFormConfig] = "getLowerPriceConfig" [tealiumConfig] = "glpTealiumConfig" [vehicles] = "glpVhicles" [storeInfo] = "glpStoreInfo" (leadResponse) = glpLeadResponse($event)></lead-form-modal>
</div>